import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from './../AuthContext';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { site_url, truck } from "./../config.js";
import { Formik } from 'formik';
import axios from 'axios';
import { IndianCurrencyFormatter, FormatDate } from './../Function';
import { useQuery } from '@tanstack/react-query';
import { Link, Navigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { ConnectivityContext } from '../context/ConnectivityContext';
import { cachedGet, cachedPostRead } from '../services/apiCacheService';

const transaction = async (user) => {
  try {
    const response = await axios.post(site_url + '/vendor/transtions', user);

    return response.data.transtions;  // Axios auto-parses JSON
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to fetch transactions');
  }
};

function Index({ children }) {

  const { user, refreshUser, vendordetails } = useContext(AuthContext);
  const { effectiveMode } = useContext(ConnectivityContext);
  const [msg, setMsg] = useState([]);
  const [Iseligible, setIseligible] = useState(false);
  const [billcustomer, setbillcustomer] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState('cash');
  const [data, setdata] = useState([]);
  const [billamount, setbillamount] = useState([]);
  const today = new Date().toISOString().split("T")[0]; // yyyy-mm-dd format
  const [fromDate, setFromDate] = useState(today);
  const [toDate, setToDate] = useState(today);

  const shopdetails = () => {
    routepath();
    // your API call / filter logic here
  };


  const showSuccessAlert = () => {
    Swal.fire({
      title: 'Success!',
      text: 'Order placed successfully',
      icon: 'success',
      confirmButtonText: 'OK',
    });
  };


  const handleSubmit = async (values, { setSubmitting, resetForm }) => {

    try {

      // API request
      const data = {
        "customerid": billcustomer.customer.id,
        "billamount": values.billamount,
        "billno": values.billno,
        "tax": values.tax,
        "paytype": paymentMethod,
        "vendorid": user.id,
      }
      const response = await axios.post(site_url + '/vendor/billpay', data);
      console.log(response);
      if (response.data.status == 'success') {
        resetForm();
        setbillcustomer();
        refreshUser();
        //  refetchtransactions();
        showSuccessAlert();
        setMsg(response.data)
      } else if (response.data.status == 'failed') {
        setMsg(response.data)
      }
      // Reset form after success
    } catch (error) {
      console.error(error);
    } finally {
      setSubmitting(false); // Stop loading spinner
    }
  };


  const routepath = async () => {
    try {
      let response;
      if (user.w_type == 1) {
        const data = {
          fromdate: fromDate,
          todate: toDate
        }
        const responseData = await cachedPostRead(site_url + '/view_collection_data_route', data, {}, effectiveMode === 'offline');
        response = { data: responseData };

      } else {
        const responseData = await cachedGet(site_url + '/workerroute/' + user.id, {}, effectiveMode === 'offline');
        response = { data: responseData };

      }
      if (response.data.status == 'success') {
        setdata(response.data.routes);
        console.log(response.data.routes);
      }
    } catch (error) {

    }
  }



  const totalbill = async () => {
    try {
      const cachedData = await cachedGet(site_url + '/totalbill/' + user.id, {}, effectiveMode === 'offline');
      const finalResponse = { data: cachedData };
      if (finalResponse.data.status == 'success') {
        setbillamount(finalResponse.data.order);
      }
    } catch (error) {

    }
  }
  useEffect(() => {

    routepath();
    totalbill();

  }, [user.id])



  return (
    <>

      <div id="appCapsule">
        {/* Wallet Card */}
        <div className="section wallet-card-section pt-1">
          <div className="wallet-card">
            {/* Balance */}
            <div className="balance">
              <div className="left">
                {/* <h2 className="title">Today Bill Amount</h2>
                <h1 className="total">₹ {(billamount ? billamount : '0')}</h1> */}
              </div>
              <div className="right">

              </div>
            </div>

          </div>
        </div>


        <div className="section mt-4">
          {(user.id == 1) ? (<>
            <div className="section-heading">
              <h2>Dashboard</h2>
            </div>

            {/* Dashboard Cards */}
            <div className="row">
              {/* Customer Card */}
              <div className="col-4 mb-3">
                <Link to="/customer" className="card dashboard-card">
                  <div className="card-body text-center">
                    <div className="dashboard-icon">
                      <i className="fas fa-users"></i>
                    </div>
                    <h6 className="card-title">Customer</h6>
                  </div>
                </Link>
              </div>

              {/* Vendor Card */}
              <div className="col-4 mb-3">
                <Link to="/workers" className="card dashboard-card">
                  <div className="card-body text-center">
                    <div className="dashboard-icon">
                      <i className="fas fa-users-cog"></i>
                    </div>
                    <h6 className="card-title">Workers</h6>
                  </div>
                </Link>
              </div>

              {/* Product Card */}
              <div className="col-4 mb-3">
                <Link to="/product" className="card dashboard-card">
                  <div className="card-body text-center">
                    <div className="dashboard-icon">
                      <i className="fas fa-box"></i>
                    </div>
                    <h6 className="card-title">Product</h6>
                  </div>
                </Link>
              </div>

              {/* Recent Bills Card */}
              <div className="col-4 mb-3">
                <Link to="/recent-bills" className="card dashboard-card">
                  <div className="card-body text-center">
                    <div className="dashboard-icon">
                      <i className="fas fa-file-invoice"></i>
                    </div>
                    <h6 className="card-title">Recent Bills</h6>
                  </div>
                </Link>
              </div>

              {/* Add Payment Card */}
              <div className="col-4 mb-3">
                <Link to="/add-payment" className="card dashboard-card">
                  <div className="card-body text-center">
                    <div className="dashboard-icon">
                      <i className="fas fa-plus-circle"></i>
                    </div>
                    <h6 className="card-title">Add Payment</h6>
                  </div>
                </Link>
              </div>

              {/* Payment Ledger Card */}
              <div className="col-4 mb-3">
                <Link to="/payment-ledger" className="card dashboard-card">
                  <div className="card-body text-center">
                    <div className="dashboard-icon">
                      <i className="fas fa-book"></i>
                    </div>
                    <h6 className="card-title">Payment Ledger</h6>
                  </div>
                </Link>
              </div>

              {/* Collection Report Card */}
              <div className="col-4 mb-3">
                <Link to="/collection-report" className="card dashboard-card">
                  <div className="card-body text-center">
                    <div className="dashboard-icon">
                      <i className="fas fa-chart-bar"></i>
                    </div>
                    <h6 className="card-title">Collection Report</h6>
                  </div>
                </Link>
              </div>

              {/* Staff Collection Report Card */}
              <div className="col-4 mb-3">
                <Link to="/staff-collection-report" className="card dashboard-card">
                  <div className="card-body text-center">
                    <div className="dashboard-icon">
                      <i className="fas fa-user-tie"></i>
                    </div>
                    <h6 className="card-title">Staff Collection</h6>
                  </div>
                </Link>
              </div>

              {/* Workers Card */}
              
            </div>


          </>):(<>
        
          
          <div className="transactions">

            {(user.w_type == 1 && <>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label>From Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      max={toDate}
                    />
                  </div>
                </div>

                {/* To Date */}
                <div className="col-md-4">
                  <div className="form-group">
                    <label>To Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      min={fromDate}
                    />
                  </div>
                </div>

                {/* Filter Button */}
                <div className="col-md-4 d-flex align-items-end">
                  <button
                    className="btn btn-primary w-100"
                    onClick={shopdetails}
                    disabled={!fromDate || !toDate}
                  >
                    Filter
                  </button>
                </div>
              </div>
              <br></br>
            </>)}

            {data?.map((item) => (


              <Link to={`/Shop?id=${item.id}&fromDate=${fromDate}&toDate=${toDate}&w_type=${user.w_type}`} className="item">

                <div className="detail">
                  <img
                    src={truck}
                    alt="img"
                    className="image-block imaged w48"
                  />
                  <div>
                    <strong>{item.name}</strong>
                  </div>
                </div>
                <div className="right">
                  <div className="price text-danger">
                  </div>
                </div>
              </Link>

            ))}



          </div>
          </>)}
        </div>
      
      </div>
      <Footer />
      <Sidebar />



    </>

  )
}
const styles = {
  container: {
    textAlign: 'center',
    padding: '15px',
    fontFamily: 'Arial, sans-serif',
  },
  optionContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    marginTop: '15px',
  },
  option: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '15px 30px',
    border: '2px solid #ccc',
    borderRadius: '10px',
    cursor: 'pointer',
    transition: 'all 0.3s ease-in-out',
    fontSize: '15px',
    width: '130px',
    height: '50px'
  },
  selectedOption: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '15px 30px',
    border: '2px solid #28a745',
    borderRadius: '10px',
    cursor: 'pointer',
    backgroundColor: '#28a745',
    color: '#fff',
    fontSize: '17px',
    width: '130px',
    height: '50px'
  },
  icon: {
    fontSize: '16px',
  },
  result: {
    marginTop: '20px',
    fontSize: '16px',
  },
};

// Add CSS styles for dashboard cards
const dashboardStyles = `
  .dashboard-card {
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    transition: all 0.3s ease;
    text-decoration: none;
    color: inherit;
    background: #fff;
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .dashboard-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
    text-decoration: none;
    color: inherit;
  }
  
  .dashboard-icon {
    font-size: 2rem;
    color: #007bff;
    margin-bottom: 8px;
  }
  
  .dashboard-card .card-title {
    font-size: 0.9rem;
    font-weight: 600;
    margin: 0;
    color: #333;
  }
  
  .dashboard-card .card-body {
    padding: 1rem;
  }
  
  @media (max-width: 768px) {
    .dashboard-card {
      min-height: 80px;
    }
    
    .dashboard-icon {
      font-size: 1.5rem;
    }
    
    .dashboard-card .card-title {
      font-size: 0.8rem;
    }
  }
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = dashboardStyles;
  document.head.appendChild(styleSheet);
}

export default Index